import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
/**
 * Audio widget i18n instance with bundled translations.
 *
 * Unlike the main widget (which runs in an iframe served from the Moveo CDN),
 * the audio widget is injected directly into the host page's DOM. This means
 * i18next-http-backend cannot fetch /public/locales/*.json — those paths would
 * resolve to the host site, not the Moveo CDN. Instead, we bundle
 * audio_widget translations inline so no HTTP requests are needed.
 */
const resources = {
    el: {
        translation: {
            audio_widget: {
                actions: {
                    cancel: 'Ακύρωση δοκιμαστικής κλήσης ήχου',
                    end: 'Τερματισμός δοκιμαστικής κλήσης ήχου',
                    start: 'Έναρξη δοκιμαστικής κλήσης ήχου',
                },
                errors: {
                    generic: 'Παρουσιάστηκε σφάλμα',
                    start_failed: 'Δεν ήταν δυνατή η έναρξη της κλήσης',
                },
                mute: {
                    mute: 'Σίγαση',
                    mute_microphone: 'Σίγαση μικροφώνου',
                    unmute: 'Κατάργηση σίγασης',
                    unmute_microphone: 'Κατάργηση σίγασης μικροφώνου',
                },
                sr: {
                    connected: 'Η κλήση συνδέθηκε',
                    connected_thinking: 'Η κλήση συνδέθηκε, δημιουργία απάντησης',
                    connecting: 'Σύνδεση κλήσης',
                    error: 'Σφάλμα κλήσης',
                    error_with_message: 'Σφάλμα κλήσης: {{message}}',
                    ready: 'Έτοιμο για πραγματοποίηση κλήσης',
                },
                status: {
                    connecting: 'Σύνδεση',
                    error: 'Σφάλμα',
                    on_call: 'Σε κλήση',
                    ready: 'Έτοιμο',
                    thinking: 'Σκέφτεται',
                },
            },
        },
    },
    en: {
        translation: {
            audio_widget: {
                actions: {
                    cancel: 'Cancel audio preview call',
                    end: 'End audio preview call',
                    start: 'Start audio preview call',
                },
                errors: {
                    generic: 'An error occurred',
                    start_failed: 'Failed to start call',
                },
                mute: {
                    mute: 'Mute',
                    mute_microphone: 'Mute microphone',
                    unmute: 'Unmute',
                    unmute_microphone: 'Unmute microphone',
                },
                sr: {
                    connected: 'Call connected',
                    connected_thinking: 'Call connected, generating response',
                    connecting: 'Connecting call',
                    error: 'Call error',
                    error_with_message: 'Call error: {{message}}',
                    ready: 'Ready to place a call',
                },
                status: {
                    connecting: 'Connecting',
                    error: 'Error',
                    on_call: 'On call',
                    ready: 'Ready',
                    thinking: 'Thinking',
                },
            },
        },
    },
    'pt-br': {
        translation: {
            audio_widget: {
                actions: {
                    cancel: 'Cancelar chamada de prévia de áudio',
                    end: 'Encerrar chamada de prévia de áudio',
                    start: 'Iniciar chamada de prévia de áudio',
                },
                errors: {
                    generic: 'Ocorreu um erro',
                    start_failed: 'Não foi possível iniciar a chamada',
                },
                mute: {
                    mute: 'Silenciar',
                    mute_microphone: 'Silenciar microfone',
                    unmute: 'Ativar',
                    unmute_microphone: 'Ativar microfone',
                },
                sr: {
                    connected: 'Chamada conectada',
                    connected_thinking: 'Chamada conectada, gerando resposta',
                    connecting: 'Conectando chamada',
                    error: 'Erro na chamada',
                    error_with_message: 'Erro na chamada: {{message}}',
                    ready: 'Pronto para iniciar uma chamada',
                },
                status: {
                    connecting: 'Conectando',
                    error: 'Erro',
                    on_call: 'Em chamada',
                    ready: 'Pronto',
                    thinking: 'Pensando',
                },
            },
        },
    },
};
const audioI18n = i18next.createInstance();
audioI18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: false,
    },
    detection: {
        order: ['navigator'],
    },
});
// eslint-disable-next-line import/no-default-export
export default audioI18n;
